import React, { useState } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainSection } from '../components/sales/PainSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { WhatYouGetSection } from '../components/sales/WhatYouGetSection';
import { PriceSection } from '../components/sales/PriceSection';
import { FinalCTA } from '../components/sales/FinalCTA';
import { LegalModal } from '../components/sales/LegalModal';
export function SalesPage() {
  const [modal, setModal] = useState<'terms' | 'privacy' | null>(null);
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-179">
      <HeroSection data-id="element-180" />
      <PainSection data-id="element-181" />
      <MechanismSection data-id="element-182" />
      <WhatYouGetSection data-id="element-183" />
      <PriceSection data-id="element-184" />
      <FinalCTA data-id="element-185" />

      <footer className="bg-slate-950 text-slate-500 py-10 text-center text-sm" data-id="element-186">
        <div className="max-w-7xl mx-auto px-4" data-id="element-187">
          <p className="mb-4" data-id="element-188">
            © {new Date().getFullYear()} Disciplina Anti-Flojera. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center space-x-6" data-id="element-189">
            <button onClick={() => setModal('terms')} className="hover:text-slate-300 transition-colors underline underline-offset-2" data-id="element-190">
              Términos y Condiciones
            </button>
            <button onClick={() => setModal('privacy')} className="hover:text-slate-300 transition-colors underline underline-offset-2" data-id="element-191">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-192" />
    </div>;
}